import { render } from "./ButtonLoading.vue?vue&type=template&id=0da3eda4"
import script from "./ButtonLoading.vue?vue&type=script&lang=js"
export * from "./ButtonLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__